import React, { useEffect, useState } from "react";
import "./homeProducts.css";
import { useDispatch, useSelector } from "react-redux";
import { showCartModal } from "../../store/slices/cartModalSlice";
import { showToast } from "../../store/slices/toastSlice";
import { Link } from "react-router-dom";
import StarRating from "./starRating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";

const HomeProductsCard = ({ product, show, setShowPopover }) => {
  function getTotalStock(colors) {
    let totalStock = 0;
    for (const color of colors) {
      totalStock += color.stock;
    }
    return totalStock;
  }
  const [inCart, setInCart] = useState(false);
  const [showBtnSpinner, setShowBtnSpinner] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);

  const cart = useSelector((state) => state.cart.cart);
  const dispatch = useDispatch();

  useEffect(() => {
    setShowBtnSpinner(false);
    let outOfStock = false;
    if (product.colors.every((obj) => obj.stock === 0)) {
      setOutOfStock(true);
      outOfStock = true;
    }
    if (!cart.items) {
      setInCart(false);
      return;
    } else if (!outOfStock) {
      console.log("color log")
    }
    const productIndx = cart.items.findIndex(
      (ele) => ele.product_id._id === product._id
    );
    setInCart(productIndx === -1 ? false : true);
  }, [cart, product]);

  const shareToSocialMedia = (value, imageUrl) => {
    if (navigator.share) {
      const shareData = {
        title: "Check out this product!",
        text: "Product Link: " + value,
        url: value,
      };

      const files = [];
      if (imageUrl) {
        fetch(imageUrl)
          .then((response) => response.arrayBuffer())
          .then((imageBuffer) => {
            const imageFile = new File([imageBuffer], "product_image.jpg", {
              type: "image/jpeg",
            });

            files.push(imageFile);
            shareData.files = files;

            navigator
              .share(shareData)
              .then(() => {
                console.log("Product link and image shared successfully!");
              })
              .catch((error) => {
                console.error("Error sharing:", error);
              });
          })
          .catch((error) => {
            console.error("Error fetching image:", error);
            navigator.share(shareData);
          });
      } else {
        navigator.share(shareData);
      }
    } else {
      copyToClipboard(value);
    }
  };
  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    dispatch(showToast("Link Copied!"));
  };

  const addToRecentlyViewed = (product) => {
    let recentlyViewed = localStorage.getItem("recentlyViewedProducts");
    recentlyViewed = recentlyViewed ? JSON.parse(recentlyViewed) : [];

    const productIndex = recentlyViewed.findIndex(
      (item) => item._id === product._id
    );
    if (productIndex === -1) {
      recentlyViewed.unshift(product);
      if (recentlyViewed.length > 10) {
        recentlyViewed.pop();
      }

      // Update local storage
      localStorage.setItem(
        "recentlyViewedProducts",
        JSON.stringify(recentlyViewed)
      );
    }
  };

  const [recentlyViewed, setRecentlyViewed] = useState(
    JSON.parse(localStorage.getItem("recentlyViewedProducts")) || []
  );

  const removeFromRecentlyViewed = (productId) => {
    const updatedRecentlyViewed = recentlyViewed.filter(
      (product) => product._id !== productId
    );
    setRecentlyViewed(updatedRecentlyViewed);
    localStorage.setItem(
      "recentlyViewedProducts",
      JSON.stringify(updatedRecentlyViewed)
    );
    window.location.reload();
  };

  return (
    <div className="showcase" itemScope itemType="https://schema.org/Product">
      <meta itemProp="sku" content={product._id} />
      <meta
        itemProp="category"
        content={product.category?.name || "Security Products"}
      />
      <meta
        itemProp="brand"
        content={product.brand || "Nakuru Security Solutions"}
      />

      <div className="showcase-banner">
        <Link
          to={`/product-details/${product._id}`}
          onClick={() => addToRecentlyViewed(product)}
          aria-label={`View details of ${product.name} security product`}
        >
          <img
            src={product.documents[0]?.url}
            alt={`${product.name} CCTV security system in Nakuru, Kenya`}
            width="300"
            className="product-img default"
            style={{ maxHeight: "200px" }}
            itemProp="image"
          />
          <img
            src={
              product?.documents[1]
                ? product?.documents[1]?.url
                : product?.documents[0]?.url
            }
            alt={`${product.name} security product installation in Nakuru`}
            width="300"
            className="product-img hover"
            style={{ maxHeight: "200px" }}
          />
        </Link>

        <p className="showcase-badge">-{product.discount}%</p>

        <div className="showcase-actions">
          <Link
            to={`/product-details/${product._id}`}
            className="btn-action"
            aria-label="Quick view of product details"
          >
            <ion-icon name="eye-outline"></ion-icon>
          </Link>
          <button
            className="btn-action"
            onClick={() =>
              shareToSocialMedia(
                `${`/product-details/${product._id}`}`,
                product.documents && product.documents[0]?.url
              )
            }
            aria-label="Share this security product"
          >
            <ion-icon name="share-outline"></ion-icon>
          </button>
          {!(outOfStock || cart.role === "admin") ? (
            showBtnSpinner ? (
              <button className="btn-action" aria-label="Adding to cart">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </button>
            ) : inCart ? (
              <button
                className="btn-action"
                onClick={() => dispatch(showCartModal(true))}
                aria-label="View shopping cart"
              >
                <ion-icon name="cart"></ion-icon>
              </button>
            ) : (
              <button
                className="btn-action"
                onClick={() =>
                  window.open(
                    `https://wa.me/254747733440?text=I am interested in: ${product.name}`
                  )
                }
                aria-label="Contact via WhatsApp about this product"
              >
                <ion-icon name="logo-whatsapp"></ion-icon>
              </button>
            )
          ) : (
            ""
          )}
          {show && (
            <button
              className="btn-action"
              onClick={() => removeFromRecentlyViewed(product._id)}
              aria-label="Remove from recently viewed"
            >
              <FontAwesomeIcon icon={faTrashCan} type="button" />{" "}
            </button>
          )}
        </div>
      </div>

      <div className="showcase-content">
        <Link
          to={`/product-details/${product._id}`}
          className="showcase-category"
          itemProp="offers"
          itemScope
          itemType="https://schema.org/Offer"
        >
          <meta itemProp="priceCurrency" content="KES" />
          <meta itemProp="price" content={product.price} />
          <meta
            itemProp="availability"
            content={
              outOfStock
                ? "https://schema.org/OutOfStock"
                : "https://schema.org/InStock"
            }
          />
          <meta
            itemProp="itemCondition"
            content="https://schema.org/NewCondition"
          />
          {getTotalStock(product.colors)} items
        </Link>

        <Link to={`/product-details/${product._id}`}>
          <h3 className="showcase-title" itemProp="name">
            {product.name.slice(0, 30)}...
          </h3>
        </Link>

        <div
          className="showcase-rating"
          itemProp="aggregateRating"
          itemScope
          itemType="https://schema.org/AggregateRating"
        >
          <meta itemProp="ratingValue" content={product.ratings} />
          <meta itemProp="reviewCount" content={product.numOfReviews || 1} />
          <StarRating rating={product.ratings} />
        </div>

        <div className="price-box">
          <p className="price" itemProp="price">
            sh. {product.price.toLocaleString()}
          </p>
          <del>
            was{" "}
            {(
              (product.discount / 100) * product.price +
              product.price
            ).toLocaleString()}
          </del>
        </div>
      </div>
    </div>
  );
};

export default HomeProductsCard;
